<template>
  <!--  素材管理->图标库-->
  <base-page-component :has-back="false" :has-nav="false" nav-title="图标库">
    <div style="background-color: #F4F8FF;height: calc(100% - 0px);">
      <div class="bg-white m-auto h-full p-v-15" style="padding-left: 80px;padding-right: 80px">

        <div class="flex a-center   m-b-15">
          <Button class="m-r-15" @click="toUploadIcon" type="primary">上传图标</Button>
          <!--          筛选区-->
          <Input placeholder="图标名称" style="width: 240px"/>
          <Button class="m-l-15">搜索</Button>
        </div>

        <Tabs type="card" class="no-border " :animated="false">
          <Tab-pane label="自定义图标" style="width: 100%;height: 100%">
            <div style="background-color: red;width: 100%;height: 100%"></div>
          </Tab-pane>
          <Tab-pane label="系统图标">
            <div :style="{'height':callapseHeight + 'px'}" style="background-color: #6661"
                 class=" scrollbar  o-y-auto">
              <Collapse v-model="panelOpened" style="width: 100%;" accordion
              >
                <Panel name="0">
                  首页图标
                  <div slot="content">
                    <div class="flex p-b-25 p-l-10" style="flex-wrap: wrap">
                      <div
                        style="height: 60px;width: 70px;background-color: white"
                        :key="index"
                        :class="{'m-l-25':index % 5===0}"
                        class="flex a-center j-center m-t-20"
                        v-for="(item,index) in list">
                        <img :src="item.url" alt="" style="width:30px;"/>
                        <!--                      <div style="width: 50px;height: 50px;background-color: red">sss</div>-->
                      </div>
                    </div>
                  </div>
                </Panel>
                <Panel name="1">
                  动态图标
                  <div slot="content">
                    <div class="flex p-b-25 p-l-10" style="flex-wrap: wrap">
                      <div
                        style="height: 60px;width: 70px;background-color: white"
                        :key="index"
                        :class="{'m-l-25':index % 5===0}"
                        class="flex a-center j-center m-t-20"
                        v-for="(item,index) in list">
                        <img :src="item.url" alt="" style="width:30px;"/>
                        <!--                      <div style="width: 50px;height: 50px;background-color: red">sss</div>-->
                      </div>
                    </div>
                  </div>
                </Panel>
                <Panel name="2">
                  商品图标
                  <div slot="content">
                    <div class="flex p-b-25 p-l-10" style="flex-wrap: wrap">
                      <div
                        style="height: 60px;width: 70px;background-color: white"
                        :key="index"
                        :class="{'m-l-25':index % 5===0}"
                        class="flex a-center j-center m-t-20"
                        v-for="(item,index) in list">
                        <img :src="item.url" alt="" style="width:30px;"/>
                        <!--                      <div style="width: 50px;height: 50px;background-color: red">sss</div>-->
                      </div>
                    </div>
                  </div>
                </Panel>
                <Panel name="3">
                  官网图标
                  <div slot="content">
                    <div class="flex p-b-25 p-l-10" style="flex-wrap: wrap">
                      <div
                        style="height: 60px;width: 70px;background-color: white"
                        :key="index"
                        :class="{'m-l-25':index % 5===0}"
                        class="flex a-center j-center m-t-20"
                        v-for="(item,index) in list">
                        <img :src="item.url" alt="" style="width:30px;"/>
                        <!--                      <div style="width: 50px;height: 50px;background-color: red">sss</div>-->
                      </div>
                    </div>
                  </div>
                </Panel>
                <Panel name="4">
                  个人中心图标
                  <div slot="content">
                    <div class="flex p-b-25 p-l-10" style="flex-wrap: wrap">
                      <div
                        style="height: 60px;width: 70px;background-color: white"
                        :key="index"
                        :class="{'m-l-25':index % 5===0}"
                        class="flex a-center j-center m-t-20"
                        v-for="(item,index) in list">
                        <img :src="item.url" alt="" style="width:30px;"/>
                        <!--                      <div style="width: 50px;height: 50px;background-color: red">sss</div>-->
                      </div>
                    </div>
                  </div>
                </Panel>
              </Collapse>
            </div>
          </Tab-pane>
        </Tabs>

      </div>


    </div>

  </base-page-component>

</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'

export default {
  name: 'IconRepository',
  components: {
    BasePageComponent,
  },
  data () {
    return {
      callapseHeight: 0,
      tableHeight: 620,
      totalPage: 99,
      pageSize: 20,
      pageNum: 1,
      panelOpened: ['0',],
      columns: [
        {
          type: 'selection',
          width: 55,
          align: 'center'
        }, {
          title: '分类',
          key: 'clazz',
          minWidth: 100
        }, {
          title: '分组',
          key: 'group',
          minWidth: 100
        }, {
          title: '图片名称',
          slot: 'picName',
          minWidth: 400
        }, {
          title: '创建人',
          key: 'createBy',
          minWidth: 100
        }, {
          title: '创建时间',
          key: 'createTime',
          minWidth: 200
        }, {
          title: '操作',
          slot: 'operation',
          width: 250,
          align: 'center'
        }],
      dataList: [
        {
          clazz: '分类1',
          group: '分组1',
          picName: '标题1',
          createBy: 'zgh',
          createTime: '2022-10-10 12:00:00',
        }, {
          clazz: '分类2',
          group: '分组2',
          picName: '标题2',
          createBy: 'zgh',
          createTime: '2022-10-10 12:00:00',
        }, {
          clazz: '分类3',
          group: '分组3',
          picName: '标题3',
          createBy: 'zgh',
          createTime: '2022-10-10 12:00:00',
        }, {
          clazz: '分类4',
          group: '分组4',
          picName: '标题4',
          createBy: 'zgh',
          createTime: '2022-10-10 12:00:00',
        }
      ],

      list: [
        {
          'url': 'https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng949d291d93abd9512b3aed774ccb0c491d69fda39d7cc86f3d33c40c1143da83',
          'type': '11',
        },
        {
          'url': 'https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngd3ea4b379e1e8e8e53cf855d1f3b99bef3d4b74d0ebdfed39499cc20aa08e5e0',
          'type': '11',
        },
        {
          'url': 'https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng7396722768e8180c226ee1e12fc39b9a40baf70f4313103a9433430e09b1c48d',
          'type': '11',
        },
        {
          'url': 'https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng2d7b3d5b6a88fdfb58ccd06ed2c035c408378a006c73dbc642d444f36bf551fa',
          'type': '11',
        },
        {
          'url': 'https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng51c640dd2a265493009defebd480c929b8b951c0584b62fbbed4b3a0337637a3',
          'type': '11',
        },

      ],
    }
  },
  mounted () {
    this.init()
  },
  activated () {
    this.setTableHeight()
  },
  methods: {
    init () {
      this.setTableHeight()

      let list = this.list
      for (let i = 0; i < 23; i++) {
        for (let j = 0; j < 5; j++) {
          list.push(list[j])
        }
      }
    },
    setTableHeight(){
      this.tableHeight = window.innerHeight - 250
      window.onresize = () => {
        this.tableHeight = window.innerHeight - 250
      }
    },
    toUploadIcon(){
      this.$router.push('/uploadicon')
    }

  }
}
</script>

<style lang="scss" scoped>
.ivu-collapse {
  border: none;
}

.no-border ::v-deep {
  .ivu-collapse > .ivu-collapse-item.ivu-collapse-item-active > .ivu-collapse-header {
    border-color: #FFFFFF;
  }

  .ivu-collapse > .ivu-collapse-item {
    border-top: none;
  }

  .ivu-collapse-content > .ivu-collapse-content-box {
    padding-top: 0;
  }

  .ivu-collapse-content {
    background-color: unset;
  }
}

</style>
